// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1xA1d","requiredAsterisk":"Info_requiredAsterisk__1mc36"};